import { Injectable } from '@angular/core';
import {NOUHINSHO_NUMBER_REG, SEIKYUUSHO_NUMBER_REG, UNUSABLE_STRING_FOR_PASSWORD_REG} from "../../shared/constants";
import {User} from "../../shared/interface/userDocument";
import firebase from "firebase/compat";
import firestore = firebase.firestore;
import {PropertyNameVsType, ResultOfTypeof} from "../../shared/interface/propertyNameVsType";

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }


  isNouhinsho(denpyouNumber: string) {
    return NOUHINSHO_NUMBER_REG.test(denpyouNumber);
  }

  isSeikyuusho(denpyouNumber: string) {
    return SEIKYUUSHO_NUMBER_REG.test(denpyouNumber);
  }

  letArrUnique<T>(arr: T[]): T[] {
    return arr
      .filter((a, i, self) => self.indexOf(a) == i);
  }

  letUsersArrUnique(userArr: User[]) {
    const addressList = userArr.map(u => u.mail);
    const uniqueAddressList = this.letArrUnique(addressList);
    return uniqueAddressList.map(mail => userArr.find(u => u.mail == mail))
  }

  keyof<T extends Object>(obj: T): Array<keyof T> {
    return Array.from(Object.keys(obj)) as any;
  }

  // toPromise()で受けとったQuerySnaphsotをオブジェクトに展開
  convertQuerySnapshotToDocuments(value: firestore.QuerySnapshot<unknown>) {
    const resultArray: any[] = []
    value.docs.forEach(doc => {
      if (doc.exists) {
        const data: any = doc.data()
        data.id = doc.id
        resultArray.push(data);
      }
    })
    return Promise.resolve(resultArray);
  }

  // toPromise()のArrayをPromise.all()で再開したときに使える
  convertQuerySnapshotArrayToDocuments(values: firestore.QuerySnapshot<unknown>[]) {
    const resultArray: any[] = [];
    values.forEach(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data: any = doc.exists ? doc.data() : null;
        if (data != null) {
          data.id = doc.id;
          resultArray.push(data);
        }
      })
    })
    return Promise.resolve(resultArray);
  }

  addParameter_fn<T extends string | number | symbol, U>
  (parameter: T, initialValue: U): ((_: unknown) => unknown) {
    return _ => {
      if (!_) return {[parameter]: initialValue};
      const __ = _ as any;
      __[parameter] = initialValue
      return __;
    }
  }

  unusableStringList(password: string) {
    const unusable = UNUSABLE_STRING_FOR_PASSWORD_REG
    const stringList = password
      .split('')
      .filter(_ => unusable.test(_))
      .filter((v1, i, self) => i === self.findIndex(v2 => v2 === v1))
      .join(', ');
    const brace = '「」'.split('');
    return brace.join(stringList);
  }

  regexFy(password: string) {
    const startAndEnd = '^$'.split('');
    const regex_needToEscape = /([\\\[\]{}()$\-^|/+*.])/g;
    const escapedString = password.replace(regex_needToEscape, '\\$1');
    return startAndEnd.join(escapedString);
  }

  //#region ユーザ定義型ガード

  validProperties(data: Record<string, unknown>, necessary: PropertyNameVsType[], optional: PropertyNameVsType[] = []) {
    return this.validPropertiesMain(false, data, necessary) &&
      (!optional.length || this.validPropertiesMain(true, data, optional));
  }

  private validPropertiesMain(isOptional: boolean, data: Record<string, unknown>, arg: PropertyNameVsType[]) {
    return arg.map(_ => {
      // optional であれば、値が存在しないならそれはそれでOK
      if (isOptional && !data[_.property]) return true;

      // type と checker の両方が渡されている場合は checker を優先
      if (!!_.checker) return _.checker(data[_.property] as unknown);
      if (!!_.type) return typeof data[_.property] === _.type;

      return false;
    }).every(_ => _);
  }

  isArrayOf(typeOrChecker: ResultOfTypeof | ((value: unknown) => boolean)) {
    return (value: unknown) => Array.isArray(value) && value.every(satisfies);
    function satisfies(_: unknown) {
      return typeof typeOrChecker === 'string' ? typeof _ == typeOrChecker : typeOrChecker(_);
    }
  }

  isArrayOfObject(className: string) {
    const regExp = new RegExp(className, 'i');
    return (value: unknown) => Array.isArray(value) && value.every(_ => regExp.test(toString.call(_)));
  }

  isDateChecker() {
    return (value: unknown) => {
      if (!this.isNotNullish(value)) return false;
      const necessaryForTimestamp: PropertyNameVsType[] = [
        {property: 'seconds', type: 'number'},
        {property: 'nanoseconds', type: 'number'},
      ]
      return value instanceof Date ||
        this.validProperties(value, necessaryForTimestamp);
    }
  }

  isNotNullish(value: unknown): value is Record<string, any> {
    return value != null;
  }

  //#endregion

}
